import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=6fe4a5c5"
import script from "./MFA.vue?vue&type=script&lang=ts"
export * from "./MFA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports